import CustomerRoute from '../../components/customer/customerRoute/CustomerRoute';
import Home from '../../components/customer/pages/home/Home';
import Search from '../../components/customer/pages/search/Search';
import Profile from '../../components/customer/pages/profile/Profile';
import Booking from '../../components/customer/pages/booking/Booking';
import PaymentStatus from '../../components/customer/pages/paymentStatus/PaymentStatus';
import Schedule from '../../components/customer/pages/schedule/Schedule';
import InfoContent from '../../components/customer/pages/infoContent/InfoContent';
import PasswordRecovery from '../../components/customer/pages/passwordRecovery/PasswordRecovery';
import Wagons from '../../components/customer/pages/wagons/Wagons';

export default {
  routes: [
    {
      key: '1',
      path: '/:lang',
      element: CustomerRoute,
      children: [{
        key: '1.1',
        path: '',
        element: Home,
      }, {
        key: '1.2',
        path: 'search',
        element: Search,
      }, {
        key: '1.4',
        path: 'profile',
        element: Profile,
      }, {
        key: '1.5',
        path: 'search/booking',
        element: Booking,
      }, {
        key: '1.6',
        path: 'payment-status/:id',
        element: PaymentStatus,
      }, {
        key: '1.7',
        path: 'schedule',
        element: Schedule,
      },
      {
        key: '1.8',
        path: 'info-content',
        element: InfoContent,
      },
      {
        key: '1.9',
        path: 'password-recovery/:code',
        element: PasswordRecovery,
      },
      {
        key: '1.10',
        path: 'wagons/:id',
        element: Wagons,
      },
      ],
    },
  ],
};
